/* */ 
(function(Buffer) {
  'use strict';
  module.exports = Pointer;
  var $Ref = require('./ref'),
      url = require('./util/url'),
      ono = require('ono'),
      slashes = /\//g,
      tildes = /~/g,
      escapedSlash = /~1/g,
      escapedTilde = /~0/g;
  function Pointer($ref, path) {
    this.$ref = $ref;
    this.path = path;
    this.value = undefined;
    this.circular = false;
  }
  Pointer.prototype.resolve = function(obj, options) {
    var tokens = Pointer.parse(this.path);
    this.value = obj;
    for (var i = 0; i < tokens.length; i++) {
      if (resolveIf$Ref(this, options)) {
        this.path = Pointer.join(this.path, tokens.slice(i));
      }
      var token = tokens[i];
      if (this.value[token] === undefined) {
        throw ono.syntax('Error resolving $ref pointer "%s". \nToken "%s" does not exist.', this.path, token);
      } else {
        this.value = this.value[token];
      }
    }
    resolveIf$Ref(this, options);
    return this;
  };
  Pointer.prototype.set = function(obj, value, options) {
    var tokens = Pointer.parse(this.path);
    var token;
    if (tokens.length === 0) {
      this.value = value;
      return value;
    }
    this.value = obj;
    for (var i = 0; i < tokens.length - 1; i++) {
      resolveIf$Ref(this, options);
      token = tokens[i];
      if (this.value && this.value[token] !== undefined) {
        this.value = this.value[token];
      } else {
        this.value = setValue(this, token, {});
      }
    }
    resolveIf$Ref(this, options);
    token = tokens[tokens.length - 1];
    setValue(this, token, value);
    return obj;
  };
  Pointer.parse = function(path) {
    var pointer = url.getHash(path).substr(1);
    if (!pointer) {
      return [];
    }
    pointer = pointer.split('/');
    for (var i = 0; i < pointer.length; i++) {
      pointer[i] = decodeURI(pointer[i].replace(escapedSlash, '/').replace(escapedTilde, '~'));
    }
    if (pointer[0] !== '') {
      throw ono.syntax('Invalid $ref pointer "%s". Pointers must begin with "#/"', pointer);
    }
    return pointer.slice(1);
  };
  Pointer.join = function(base, tokens) {
    if (base.indexOf('#') === -1) {
      base += '#';
    }
    tokens = Array.isArray(tokens) ? tokens : [tokens];
    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];
      base += '/' + encodeURI(token.replace(tildes, '~0').replace(slashes, '~1'));
    }
    return base;
  };
  function resolveIf$Ref(pointer, options) {
    if ($Ref.isAllowed$Ref(pointer.value, options)) {
      var $refPath = url.resolve(pointer.path, pointer.value.$ref);
      if ($refPath === pointer.path) {
        pointer.circular = true;
      } else {
        var resolved = pointer.$ref.$refs._resolve($refPath, options);
        if ($Ref.isExtended$Ref(pointer.value)) {
          pointer.value = $Ref.dereference(pointer.value, resolved.value);
        } else {
          pointer.$ref = resolved.$ref;
          pointer.path = resolved.path;
          pointer.value = resolved.value;
        }
        return true;
      }
    }
  }
  function setValue(pointer, token, value) {
    if (pointer.value && typeof pointer.value === 'object') {
      if (token === '-' && Array.isArray(pointer.value)) {
        pointer.value.push(value);
      } else {
        pointer.value[token] = value;
      }
    } else {
      throw ono.syntax('Error assigning $ref pointer "%s". \nCannot set "%s" of a non-object.', pointer.path, token);
    }
    return value;
  }
})(require('buffer').Buffer);
